import React from 'react';
import PropTypes from 'prop-types';
import { SchemaOrg } from 'project/schema-org';

import { ContentType } from 'components/content-type';
import { mediaTypes } from 'components/posts';

class RelatedNews extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
    }

    renderContentType(model) {
        if (
            model.type === mediaTypes.VIDEO_PLAYER
        ) {
            return (
                <div className="related-news__content-type">
                    <ContentType type={model.type} />
                </div>
            );
        }

        return null;
    }

    render() {
        const { model } = this.props;
        return (
            <section className="related-news">
                <div className="related-news__wrapper">
                    <ul className="news-related-news__list">
                        {model.map((item, index) => (
                            <li className='related-news__item' key={index}>
                                <a className="related-news__link" href={item.url}>
                                    <div className='related-news__link-wrapper'>
                                        <div className='related-news__background'>
                                            {this.renderContentType(item)}
                                            <img
                                                className="lazyload predefined-size"
                                                data-srcset={item.bgImage}
                                                alt=""
                                                data-sizes="auto"
                                            />
                                        </div>
                                        <div className='related-news__content-wrapper'>
                                            <div className='related-news__content'>
                                                <h4 className='related-news__label'>{item.label}</h4>
                                                <h2 className='related-news__title-wrapper'>
                                                    <span className='related-news__title'>{item.title}</span>
                                                    <span className='related-news__separator'>/</span>
                                                    <span className='related-news__subtitle'>{item.subtitle}</span>
                                                </h2>
                                                <div className="related-news__cta-text-wrapper">
                                                    <svg className="related-news__cta-text-icon" width="16" height="14" focusable="false">
                                                        <use xlinkHref="#icon-arrow-right"></use>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <SchemaOrg model={item.schemaOrg} />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        );
    }
}

RelatedNews.propTypes = {
    model: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RelatedNews;
